/**
 * 단일 전략 백테스트 탭 구성
 */
import { Dispatch, SetStateAction } from 'react';
import { SectionCard } from '../common/SectionCard';
import BacktestForm from './BacktestForm';
import BacktestResultPanel from './BacktestResultPanel';
import { BacktestResult, StrategyInfo } from '../../services/backtestApi';
import './BacktestSingleTab.css';

interface BacktestSingleTabProps {
  symbol: string;
  onSymbolChange: Dispatch<SetStateAction<string>>;
  strategy: string;
  onStrategyChange: Dispatch<SetStateAction<string>>;
  period: '3M' | '6M' | '1Y';
  onPeriodChange: Dispatch<SetStateAction<'3M' | '6M' | '1Y'>>;
  initialCapital: number;
  onInitialCapitalChange: Dispatch<SetStateAction<number>>;
  strategies: StrategyInfo[];
  loading: boolean;
  result: BacktestResult | null;
  interpretation: string | null;
  onRun: () => void;
}

export default function BacktestSingleTab({
  symbol,
  onSymbolChange,
  strategy,
  onStrategyChange,
  period,
  onPeriodChange,
  initialCapital,
  onInitialCapitalChange,
  strategies,
  loading,
  result,
  interpretation,
  onRun,
}: BacktestSingleTabProps) {
  return (
    <div className="backtest-section-stack">
      <SectionCard
        title="단일 전략 백테스트"
        subtitle={`${symbol || '종목'} · ${strategy} 전략 · ${period}`}
      >
        <BacktestForm
          symbol={symbol}
          onSymbolChange={onSymbolChange}
          strategy={strategy}
          onStrategyChange={onStrategyChange}
          period={period}
          onPeriodChange={onPeriodChange}
          initialCapital={initialCapital}
          onInitialCapitalChange={onInitialCapitalChange}
          strategies={strategies}
        />

        <button
          onClick={onRun}
          disabled={loading}
          className="backtest-run-btn"
        >
          {loading ? '실행 중...' : '백테스트 실행'}
        </button>
      </SectionCard>

      {result && (
        <BacktestResultPanel result={result} interpretation={interpretation} />
      )}
    </div>
  );
}
